
export default {
    proficiencia: {},
    proficiencias: []
}